export { Template as EstatePlanningRecommendationQualificationFailedStepTemplate } from './Template';
